import {
  ListCell,
  ListDrawer,
  ListRow,
  StatusLabel,
} from "@administrate/piston-ux";
import { FormConsumer } from "@administrate/piston-ux/lib/Form";
import { hasErrors } from "@administrate/piston-ux/lib/Submit";
import { ColorOptions } from "@administrate/piston-ux/lib/types";
import { Observer, observer } from "mobx-react-lite";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import {
  Contact,
  Maybe,
  PointOfSaleLearnerFieldDefinition,
} from "../../generated/weblinkTypes";
import { ContactPicker } from "../ContactPicker";
import { PointOfSaleLearnerFields } from "../PointOfSaleLearnerFields";
import { UNNAMED_LEARNER_CONTACT } from "./selectedContact";

export type LearnerRowType = {
  contacts(inputValue: string): Promise<any>;
  onChange(newValue: Contact, oldValue: Maybe<Contact>, index: number): void;
  posFields?: PointOfSaleLearnerFieldDefinition[];
  disabled: boolean;
};

export const LearnerRow: FunctionComponent<LearnerRowType> = ({
  contacts,
  onChange,
  posFields,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <FormConsumer>
      {({ values, arrayIndex }) => {
        return (
          <Observer>
            {() => (
              <ListRow gridColumns="140px 1fr">
                <ListCell label={t("learnerNumber")}>
                  <FormConsumer>
                    {({ errors }) => (
                      <LearnerStatusLabel
                        errors={errors}
                        hasLearner={!(values.id === UNNAMED_LEARNER_CONTACT.id)}
                        arrayIndex={arrayIndex}
                      />
                    )}
                  </FormConsumer>
                </ListCell>
                <ListCell
                  label={t("learnerInformation")}
                  extraClass="learners--information"
                >
                  <ContactPicker
                    name={`contact`}
                    loadOptions={contacts}
                    onChange={(newValue, oldValue) =>
                      onChange(newValue, oldValue, arrayIndex)
                    }
                    valid={v => !!v}
                    disabled={disabled}
                  />
                </ListCell>
                {posFields && !(values.id === UNNAMED_LEARNER_CONTACT.id) && (
                  <ListDrawer
                    title={t("learnerInformation")}
                    open={true}
                    display="hidden"
                  >
                    <PointOfSaleLearnerFields
                      posFields={posFields}
                      contactId={values.id || undefined}
                      learnerNumber={arrayIndex}
                    />
                  </ListDrawer>
                )}
              </ListRow>
            )}
          </Observer>
        );
      }}
    </FormConsumer>
  );
};

export const LearnerStatusLabel: FunctionComponent<{
  errors: any;
  hasLearner?: boolean;
  arrayIndex: number;
}> = observer(({ errors, hasLearner, arrayIndex }) => {
  const { t } = useTranslation();
  return (
    <StatusLabel
      color={
        hasErrors(errors)
          ? ColorOptions.Red
          : hasLearner
            ? ColorOptions.Green
            : ColorOptions.LightGrey
      }
      text={`${t("learner")} ${arrayIndex + 1}`}
    />
  );
});
